
// import HtmlPanel from './common/HtmlPanel.vue'
// 这里是重点
const commonComponents = {
    install (Vue) {
        // Vue.component('HtmlPanel', HtmlPanel)
    }
}
export {

}
// 导出组件
export default commonComponents
